import React, {useContext} from "react";
import {AppState} from "lib/context/AppProvider";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {Row} from "react-bootstrap";
import logo from "lib/assets/img/logoDouble.png";
import {useMediaQuery} from "react-responsive";
import {useASTAuthContext} from "lib/helpers/ASTAuthProvider";
import "bootstrap-icons/font/bootstrap-icons.css";

const LoginScreen = () => {
    const {store} = useContext(AppState);
    const {user} = store;

    const isMobile = useMediaQuery({query: "(max-width: 760px)"});

    const {federatedLogin} = useASTAuthContext();

    const handleSubmit = async (e) => {
        e.preventDefault();
    };

    const loginForm = (
        <Form onSubmit={handleSubmit}>
            { /* New button for AST credentials */}
            <Row className="py-1 place-center px-4 mx-4">
                <Button variant="primary" onClick={federatedLogin}>
                        Block 1 Login
                </Button>
            </Row>
        </Form>
    );

    return (
        !user.isLoggedIn
        && <div className="loginscreen">
            <div className="loginform place-center">
                <img className="login-logo" src={logo} alt="logo" height={isMobile ? 70 : 85}/>
                <p className="login-text" style={{fontSize: "30px", fontFamily: "Poppins, sans-serif"}}>SATVIEW</p>
                { loginForm }
            </div>
        </div>
    );
};

export default LoginScreen;
